export default class BackendError extends Error {
	public readonly code: String;

	constructor(code: string) {
		super(code);

		this.code = code;

		// Without this, 'instanceof BackendError' will return false
		Object.setPrototypeOf(this, BackendError.prototype);
	}
}
